var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 500 500",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 73.223,
    x2: 426.777,
    y1: 73.223,
    y2: 426.777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57cdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096d6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    gradientUnits: "userSpaceOnUse",
    x1: 201.668,
    x2: 214.993,
    y1: 119.012,
    y2: 132.337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 217.641,
    x2: 280.915,
    xlinkHref: "#linear-gradient-2",
    y1: 174.715,
    y2: 237.99
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 216.96,
    x2: 414.29,
    xlinkHref: "#linear-gradient-2",
    y1: 241.943,
    y2: 439.273
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_24.Circle_Solid_Gradient_Shadow",
    "data-name": "24.Circle_Solid_Gradient_Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#linear-gradient)",
    height: 500,
    rx: 250,
    width: 500
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.33 139v-26.65l12.57 12.57a59.618 59.618 0 0 0 -12.57 14.08z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.97 240.55q-11.97-12.465-11.97-34.07 0-21.585 11.97-34.08a38.962 38.962 0 0 1 29.19-12.48 39.576 39.576 0 0 1 29.52 12.32q11.97 12.315 11.97 33.9 0 21.6-12.14 34.24a40.353 40.353 0 0 1 -58.54.17z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.08 304.333a250.137 250.137 0 0 1 -233.98 195.467l-109.46-109.447h57.69v-116.06q8.43 12.825 23.45 20.92t34.58 8.09a77.167 77.167 0 0 0 42.17-11.97q18.9-11.97 29.86-34.08 10.965-22.095 10.97-51.11t-10.97-50.943a87.908 87.908 0 0 0 -14.07-20.62z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.613 117.75q14.841-8.1 34.749-8.1a77.974 77.974 0 0 1 42.172 11.808q18.891 11.814 29.858 33.737t10.965 50.944q0 29.019-10.965 51.111t-29.858 34.075a77.127 77.127 0 0 1 -42.172 11.977q-19.571 0-34.581-8.1t-23.447-20.917v116.062h-57.691v-277.995h57.691v26.653a62.577 62.577 0 0 1 23.279-21.255zm47.064 54.486a39.571 39.571 0 0 0 -29.52-12.314 38.919 38.919 0 0 0 -29.183 12.478q-11.981 12.49-11.974 34.079t11.977 34.075a40.365 40.365 0 0 0 58.534-.169q12.144-12.653 12.145-34.243t-11.979-33.906z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.f92e3a5cdae5ac8cfdd906ceae1c476b.svg";
export { ForwardRef as ReactComponent };